(() => {
  'use strict';

  const pad = (n) => String(n).padStart(2, '0');

  function getSecondsUntilEndOfDay() {
    const now = new Date();
    const endOfDay = new Date(now);
    endOfDay.setHours(24, 0, 0, 0);
    return Math.floor((endOfDay - now) / 1000);
  }

  const countdownTimer = document.querySelector('.nextdev--sale-line--timer');
  if (!countdownTimer) return;

  const hoursEl   = countdownTimer.querySelector('.nextdev--sale-line--timer__hours');
  const minutesEl = countdownTimer.querySelector('.nextdev--sale-line--timer__minutes');
  const secondsEl = countdownTimer.querySelector('.nextdev--sale-line--timer__seconds');
  if (!hoursEl || !minutesEl || !secondsEl) return;

  let countdownSeconds = getSecondsUntilEndOfDay();

  function updateTimer() {
    hoursEl.textContent   = pad(Math.floor(countdownSeconds / 3600));
    minutesEl.textContent = pad(Math.floor((countdownSeconds % 3600) / 60));
    secondsEl.textContent = pad(countdownSeconds % 60);

    secondsEl.classList.remove('flash');
    void secondsEl.offsetWidth;
    secondsEl.classList.add('flash');

    if (countdownSeconds > 0) {
      countdownSeconds--;
    } else {
      countdownSeconds = getSecondsUntilEndOfDay();
    }
  }

  updateTimer();
  setInterval(updateTimer, 1000);
  countdownTimer.classList.remove('hidden');
})();